
import { ColumnMove, ColumnBib, ColumnName, ColumnNoc, ColumnExpander } from "components/common/TableColumns"
import { ColumnIntermediateRank, ColumnIntermediateDistance, ColumnIntermediateTime, ColumnIntermediateDiff } from "components/common/TableColumnsIntermediates"
import { hasConfig } from "components/sports/mtb/helper/MtbHelpers"




export function TableColumns(columnsAdded) {

    return (
        [
            ColumnIntermediateRank({ hasIrm: false }),
            ColumnMove({ type: 'extendedResults' }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnIntermediateDistance({ config: columnsAdded, showLaps: true }),
            ColumnIntermediateTime({}),
            ColumnIntermediateDiff({}),
            ColumnExpander({ type: hasConfig ? 'alwaysTrue' : 'alwaysTrue' })
        ]
    )
}


export function TableColumnsSM(columnsAdded) {

    return (
        [
            ColumnIntermediateRank({ hasIrm: false }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnIntermediateDistance({ config: columnsAdded }),
            ColumnIntermediateTime({}),
            ColumnExpander({ type: hasConfig ? 'alwaysTrue' : 'alwaysTrue' })
        ]
    )
}

export default TableColumns

